module.exports = __webpack_public_path__ + "img/learning.61232017.png";